import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

export class AnchorsUtils {
  // TODO support different offsets based on breakpoint

  private location: Location;
  private loopInterval: number;
  private previousUrl: URL;

  constructor(
      private router: Router,
      private renderer: Renderer2,
      @Inject(DOCUMENT) private document: Document,
      private offset: number = 0,
      private loopIntervalTime: number = 500, // milliseconds (half second)
      private loopCounter: number = 10) {


    this.onRouteChange();
    this.onLinkClick();
  }

  public scrollToAnchor(): void {
    this.resetLoop();

    this.location = window.location;
    if (this.location.href.includes('/#')) {

      if (!this.location.hash) {

        //anchor to top
        window.scrollTo({top: 0});

      } else {

        const anchorElement = document.getElementById(this.location.hash?.replace('#', ''));

        if (anchorElement) {
          this.manualScroll(anchorElement);

        } else {
          this.timingScroll();
        }
      }
    }  else {
      this.timingScroll();
    }
  }

  timingScroll(): void {
    // loop
    let loopCounter = this.loopCounter;
    this.loopInterval = window.setInterval(() => {

      if (loopCounter === 0) {
        this.resetLoop();

      } else {

        loopCounter--;

        const anchorElement = document.getElementById(this.location.hash?.replace('#', ''));

        if (anchorElement) {
          this.manualScroll(anchorElement, 'smooth', () => this.resetLoop())
        }
      }
    }, this.loopIntervalTime);
  }

  private manualScroll(anchorElement: HTMLElement | null, behavior?: 'auto' | 'smooth', cb?): void {
    cb();
    var marginTop = this.getStyle(anchorElement, 'margin-top');

    window.scrollTo({
      top: (anchorElement?.offsetTop - parseInt(marginTop, 10)) + this.offset,
      behavior,
    });
  }

  private onRouteChange(): void {
    this.router.events
        .pipe(filter(event => event instanceof NavigationStart || event instanceof NavigationEnd)) // event instanceof NavigationStart ||
        .subscribe((event: NavigationStart | NavigationEnd) => {


          if (event instanceof NavigationStart) {

            this.renderer.addClass(this.document.body.parentElement, 'start-navigation');

            const newUrl = new URL(`${location.origin}${event.url}`);


            if (this.previousUrl && newUrl.pathname === this.previousUrl.pathname) {
              this.renderer.addClass(this.document.body.parentElement, 'same-page-navigation');
            } else {
              this.renderer.removeClass(this.document.body.parentElement, 'same-page-navigation');
            }


          } else {
            setTimeout(() => {
              this.renderer.removeClass(this.document.body.parentElement, 'start-navigation');
            }, 1);

            this.scrollToAnchor();

            setTimeout(() => {
              this.renderer.addClass(this.document.body.parentElement, 'same-page-navigation');
            }, 1000);

            this.previousUrl = new URL(`${location.origin}${event.urlAfterRedirects}`);

            // console.log('onRouteChange', this.previousUrl.href);
          }
        });
  }

  private onLinkClick(): void {
    // Listen for the event.
    window.addEventListener('linkClicked', (e) => {
      if (e['detail'].link() === this.previousUrl.href) {

        // console.log('onLinkClick', e['detail'].link(), this.previousUrl.href);
        this.scrollToAnchor();
      }
    }, false);
  }

  private resetLoop() {

    if (this.loopInterval) {
      clearInterval(this.loopInterval);
    }
  }

  private getStyle(e, styleName): string {
    var styleValue = '';
    if (document.defaultView && document.defaultView.getComputedStyle) {
      styleValue = document.defaultView.getComputedStyle(e, '').getPropertyValue(styleName);
    } else if (e.currentStyle) {
      styleName = styleName.replace(/\-(\w)/g, function (strMatch, p1) {
        return p1.toUpperCase();
      });
      styleValue = e.currentStyle[styleName];
    }
    return styleValue;
  };
}
